import request from '@/utils/request'
import setting from '@/settings'
import qs from 'qs'
const apiUrl = setting.apiUrl

/**
 * 新增院校授权
 * @param data
 */
export const insertProSch = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/proSch/insert`,
    method: 'post',
    data
  })

/**
 * 根据代理id获取院校授权列表
 * @param data
 */
export const getProSchListByProxyId = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/proSch/getProSchListByProxyId?currentPage=${data.currentPage}&pageSize=${data.pageSize}`,
    method: 'post',
    data
  })

/**
 * 获取代理用户列表
 * @param data
 */
export const getAgentList = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/user/searchProUser`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取代理用户列表总数
 * @param data
 */
export const getAgentCount = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/user/searchProUserCount`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
* 新增代理用户
* @param data
*/
export const addProUser = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/user/addProUser`,
    method: 'post',
    data
  })

/**
* 修改代理用户
* @param data
*/
export const upDateProUser = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/user/updateProUser`,
    method: 'post',
    data
  })

/**
 * 获取客户中心列表
 * @param data
 */
export const getMemberList = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/user/ordinaryUserList`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取客户中心列表总数
 * @param data
 */
export const getMemberCount = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/user/ordinaryUserListCount`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
* 批量重置密码
* @param data
*/
export const resetPwd = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/user/batchResetPwds`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
* 根据用户id获取代理用户详情
* @param data
*/
export const getUserById = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/user/getUserById`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取用户操作日志
 * @param data
 */
export const userLogList = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/userLog/list?currentPage=${data.currentPage}&pageSize=${data.pageSize}`,
    method: 'post',
    data
  })

/**
 * 获取用户操作日志总数
 * @param data
 */
export const userLogCount = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/userLog/listCount`,
    method: 'post',
    data
  })

/**
 * 清空openId
 * @param data
 */
export const resetOpenId = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/user/unbundlingWechat`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 检验未结算数据
 * @param data
*/
export const checkUntreated = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/proxySettlement/checkUntreated`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 启动代理/公司用户
 * @param data
 */
export const enableProUser = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/user/enableProUser`,
    method: 'post',
    data
  })

/**
 * 禁用代理/公司用户
 * @param data
 */
export const disableProUser = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/user/disableProUser`,
    method: 'post',
    data
  })

/**
 * 启动代理/公司用户扫码状态
 * @param data
 */
export const enableProUserScanStatus = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/user/disableScanStatus`,
    method: 'post',
    data
  })

/**
 * 禁用代理/公司用户扫码状态
 * @param data
 */
export const disableProUserScanStatus = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/user/disableScanStatus`,
    method: 'post',
    data
  })

/**
 * 获取升级详情
 * @param data
*/
export const getOrdinaryUserById = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/user/getOrdinaryUserById`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 升级保存
 * @param data
*/
export const updateOrdinaryUser = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/user/updateOrdinaryUser`,
    method: 'post',
    data
  })
